import React, { useContext, useRef,useEffect,useState } from "react";
import { NavLink } from "react-router-dom";
import AdminNavbarLinks from "../Navbars/AdminNavbarLinks.jsx";
import logo from "assets/img/eseal-white.png";
import { PostAPI } from "api/post.js";
import { loopBackDomain, loopBackPort } from "environment/environment";
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import { LanguageContext } from "context/LanguageContext"
import 'assets/css/custom.css';
import { NavDropdown } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { RedisDataContext } from "context/RedisDataContext";
import Cookies from 'universal-cookie';
import { Redirect } from "react-router-dom";
const cookies = new Cookies();
let urlhost = window.location.host;
let domain = urlhost.split('.')[0];


const Sidebar = props => {
  const { t, i18n } = useTranslation();
  const [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  const [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  const [width, setWidth] = useState(window.innerWidth);
  const sidebarFeatures = useContext(RedisDataContext);
  const language = useContext(LanguageContext);
  const [tabTitle, setTabTitle] = useState(document.title);
  const [activeCard, setActiveCard] = useState(null);
  const [isSidebarChanged, setIsSidebarChanged] = useState(null)
  const navRef = useRef(null)
  const [expandedSidebar, setExpandedSidebar] = useState([]);
  const [expandState, setExpandState] = useState({});

  function activeRoute(routeName) {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }

  function updateDimensions() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    if (document.cookie.indexOf('tabTitle') == -1 ) {
      document.title =   tabTitle
    }else{
      document.title = cookies.get('tabTitle')
    }
  },[tabTitle])

  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',
    }
  ]
  
    const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
    const title =  props.routes 
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)

  useEffect(() => {
    let urlPath = window.location.pathname;
    title.forEach(element => {
      if(element.hasOwnProperty('submenuitem')) {
        element.submenuitem.forEach(element => {
        const stringExists = urlPath.includes(element.path);
        if (stringExists) {
          (async () => {
            let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
            const payload = {
              pageTypeID: element.pageTypeId,
              featureID: element.featureId,
              language: currentLanguageCode === 'en' ? 'english' : 'chinese'
            };
            cookies.set('feature_id', element.featureId, { path: '/' });
            cookies.set('pagetype_id', element.pageTypeId, { path: '/' });
            if(isSidebarChanged === false){
              await setGlobalLoadIndicator('1');
              let response = await PostAPI(url, payload);
              await setFeatureBlueprint(response);
              await setGlobalLoadIndicator('2');
              return; 
            }
            return;  
          })()
        }     
        })
      }
      else {
        let payload;
        if(window.location.pathname == '/admin/dashboard/') {
        (async () => {
          let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
          (domain === 'valvoline') ? 
          payload = {
            pageTypeID: 1,
            featureID: 1
          } :
          payload = {
            pageTypeID: 7,
            featureID: 1,
            language: currentLanguageCode === 'en' ? 'english' : 'chinese'
          }
          cookies.set('feature_id', 1, { path: '/' });
          (domain === 'valvoline') ? cookies.set('pagetype_id', 1, { path: '/' }) :
          cookies.set('pagetype_id', 7, { path: '/' });
          if(isSidebarChanged === false){
            await setGlobalLoadIndicator('1');
            let response = await PostAPI(url, payload);
            await setFeatureBlueprint(response);
            await setGlobalLoadIndicator('2');
            return;
          }
          return;
        })()
        } 
      }
    });
  }, [window.location.pathname])

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions.bind(this));   
     let urlPath = window.location.pathname;
     title.forEach((element,key) => {
      if(element.hasOwnProperty('submenuitem')) {
        element.submenuitem.forEach(element => {
      const stringExists = urlPath.includes(element.path);
      if (stringExists) {
        (async () => {
          let featureID = cookies.get('feature_id');
          let pageTypeID = cookies.get('pagetype_id');
          let language = localStorage.getItem('i18nextLng')
          if (featureID && pageTypeID) {
            setGlobalLoadIndicator('1');
            await getFeatureYMLOnLoad(parseInt(pageTypeID), parseInt(featureID), language);
            setGlobalLoadIndicator('2');
          }
        })()
        setActiveCard(key)
      }
    })
  }else {

  }
    });
  }, [sidebarFeatures]);

  useEffect(() => {
    if (document.cookie.indexOf('tabTitle') == -1 ) {
      document.title =   tabTitle
    }else{
      document.title = cookies.get('tabTitle')
    }
  },[tabTitle])

  async function getFeatureYMLOnLoad(pageTypeID, featureID, language) {
    if (Object.keys(featureBlueprint).length == 0) {
      let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
      const pageTypeId = {
        pageTypeID: pageTypeID,
        featureID: featureID,
        language : language === 'en' ? 'english' : 'chinese'
      };
      let response = await PostAPI(url, pageTypeId);
      setFeatureBlueprint(() => {
        return response;
      });
    }
    return true;
  }
  useEffect((e) => {
    document.addEventListener("click", handleOutsideClick, true)
  } ,[])

  const handleOutsideClick = (e) =>{
    if(navRef.current && !navRef.current.contains(e.target)){
      setActiveCard(null);
    }
  }

  async function getFeatureYML(e, prop) {
    let title = tabTitle.split("-")[0]
    setTabTitle(`${title} - ${prop.name}`)
    cookies.set('tabTitle', `${title} - ${prop.name}`, { path: '/' });
    let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
    const payload = {
      pageTypeID: prop.pageTypeId,
      featureID: prop.featureId,
      language: currentLanguageCode === 'en' ? 'english' : 'chinese'
    };
    cookies.set('feature_id', prop.featureId, { path: '/' });
    await setGlobalLoadIndicator('1');
    let response = await PostAPI(url, payload);
    setIsSidebarChanged(true)
    await setFeatureBlueprint(response);
    await setGlobalLoadIndicator('2');
    return;
  }

  const sidebarBackground = {
    backgroundImage: "url(" + props.image + ")"
  };

  function setChildFeatures(prop) {
    return prop.submenuitem.map((childItem, childKey) => {
      if (childItem.invisible) return null;
      return (
        <li className={activeRoute(childItem.layout + childItem.path)} key={childKey}>
          <NavLink
            onClick={((child) => getFeatureYML(child, childItem))}
            value={childItem.pageTypeId}
            to={childItem.layout + childItem.path}
            className="nav-link"
            activeClassName="active"
          >
            <i className={childItem.icon} />
            <p >{childItem.name}</p>
          </NavLink>
        </li>
      );
    })
  }

  const handleHomeTab = (key) => {
    handleNavDropDown(key)
  }

  const handleNavDropDown = (key) => {
    const currentExpandedSidebar = expandedSidebar;
    if(expandedSidebar[expandedSidebar.length-1] !== key){
      currentExpandedSidebar.pop()
    }
    const isSidebarExpanded = currentExpandedSidebar.includes(key);

    let obj = {};
    isSidebarExpanded ? (obj[key] = false) :  (obj[key] = true);
    setExpandState(obj)
    
    const newExpandedSidebar = isSidebarExpanded
      ? currentExpandedSidebar.filter((id) => id !== key)
      : currentExpandedSidebar.concat(key);
      setExpandedSidebar(newExpandedSidebar);
}

  useEffect(() => {
    if(activeCard !== null){
      handleNavDropDown(activeCard)
    }
  }, [activeCard])
  return (
    <div>
     {!(cookies.get('accessToken')) ?
       <Redirect to={{ pathname: "/login" }} />
      : ''}
    <div
      id="sidebar"
      className="sidebar"
      data-color={props.color}
      data-image={props.image}
    >
      {props.hasImage ? (
        <div className="sidebar-background" style={sidebarBackground} />
      ) : (
          null
        )}
      <div className="logo">
        <a
          style={{ width: '100%' }}
          href="http://eseal.io"
          className=" logo-mini"
          rel="noopener noreferrer"
          target="_blank"
        >
          <div style={{ width: '100%' }} className="logo-img">
            <img style={{ width: '60%', marginLeft: '30px', marginTop:'10px' }} src={logo} alt="logo_image" />
          </div>
        </a>
      </div>
      <div className="sidebar-wrapper scrollbar scrollbar-rare-wind" ref = {navRef}>
        <ul className="nav">
          {width <= 991 ? <AdminNavbarLinks /> : null}
          {title.map((prop, key) => {
            if (prop.invisible) return null;
            return (
              (prop.submenu == false)
                ?
                <li className={activeRoute(prop.layout + prop.path)} key={key} >
                  <NavLink
                    onClick={((e) => {
                      getFeatureYML(e, prop)
                      handleHomeTab(key)
                    })}
                    value={prop.pageTypeId}
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className={`${prop.icon} home-icon`} />
                    <p className={"home-text"} >{t(prop.name)}</p>
                  </NavLink>
                </li>
                :
                <NavDropdown
                  open={expandedSidebar.includes(key) && expandState[key] ? true : false}  
                  eventKey={key}
                  onClick={() => handleNavDropDown(key)}
                  title={
                 <div style={{marginTop :"5px" , marginLeft:"-16px"}}>
                      <i className={prop.icon} style={{marginRight:'10px'}}/>
                      <p style={{marginRight:"-12px"}} >
                        {prop.name}<i className={expandState[key]? "pe-7s-angle-up":"pe-7s-angle-down"} style={{ float: 'right', marginRight :"-11px"}} />
                      </p>
                      </div>
                  }
                  noCaret
                >
                  {setChildFeatures(prop)}
                </NavDropdown>
            );
            return null;
          })}
        </ul>
      </div>
    </div>
  </div>
  );
}

export default Sidebar;
